import { post, get } from '@tools/request';

// 发送验证码
export function sendVerifyCode(param) {
  return post('/ucenter/send-validation-code', param, true);
}

// 校验验证码是否OK
export function verifyCode(param) {
  return post('/ucenter/verify-validation-code', param, true);
}

// 重置邮箱密码
export function resetEmailPwd(param) {
  return post('/ucenter/reset-password-email', param, true);
}

// 重置邮箱密码
export function resetPhonePwd(param) {
  return post('/ucenter/reset-password-phone', param, true);
}

// 获取区号列表
export function getCountryCodes() {
  return get('ucenter/country-codes');
}
